<template>
  <div class="classical-list-wrapper">
    <div class="classical-search">
      <form @submit.prevent="searchClassical" action="" class="search-box">
        <icon icon-class="search"></icon>
        <input type="search" ref="searchInput" placeholder="请搜索方名或功能主治" v-model="searchKey" name="" id="">
        <icon icon-class="close" class="clear" @click.native="clearSearch" v-show="searchKey"></icon>
      </form>
    </div>
    <div class="list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="classical-list" v-else-if="dataDone && classicalList.length > 0">
      <router-link :to="{name: 'ClassicalDetail', params: {id: item.id}}" tag="div" class="classical-item" :key="index" v-for="(item, index) in classicalList">
        <div class="classical-box">
          <div class="classical-name">{{item.title}}</div>
          <icon icon-class="arrow"></icon>
        </div>
      </router-link>
      <div class="data-loading" v-if="!isOver"><van-loading type="spinner" size="14px">加载中...</van-loading></div>
      <div class="data-finish" v-if="isOver">无更多数据</div>
    </div>
    <div class="empty-classical" v-else-if="dataDone && classicalList.length == 0">
      <icon icon-class="empty-classical"></icon>
      <p>暂时还没有患者</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .classical-list-wrapper{
    min-height: 100vh;
    background: #FAFAFA;
    .list-loading{
      padding-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .classical-search{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 57px;
      border-bottom: 1px solid #F2F0EC;
      padding: 10px 16px;
      background: #FFF;
      z-index: 10;
      .search-box{
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F7F7F7;
        border-radius: 3px;
        overflow: hidden;
        svg{
          font-size: 16px;
          color: #CCC;
          margin-left: 13px;
          &.clear{
            color: #999;
            margin-right: 8px;
            font-size: 14px;
          }
        }
        input{
          flex: 1;
          height: 100%;
          background: #F7F7F7;
          font-size: 14px;
          color: @black;
          padding: 0 8px;
          &[type=search]::-webkit-search-cancel-button{
            -webkit-appearance: none;
          }
        }
      }
    }
    .classical-list{
      padding-top: 57px;
      width: 100%;
      .classical-item{
        padding-left: 24px;
        height: 58px;
        .classical-box{
          height: 100%;
          border-bottom: 1px solid #EEEEEE;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 24px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        searchKey: '',
        classicalList: [],
        page: 1,
        isOver: false,
        timer: null,
      }
    },
    created() {
      this.getClassicalList();
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToLoad);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.scrollToLoad);
    },
    methods: {
      getClassicalList(type = 'normal', cb) {
        this.$root.post('/getClassicalPretList', {
          count: 20,
          page: this.page,
          search: this.searchKey
        }).then(data => {
          this.dataDone = true;
          if(data && data.info.length <= 0 && type == 'search' && this.classicalList.length > 0) {
            this.$notify('暂无搜索结果');
          }
          this.isOver = data.is_over == 1 ? true : false;
          if(data && data.info.length > 0) {
            if(type == 'search') {
              this.classicalList = data.info;
            }else {
              this.classicalList = [...this.classicalList, ...data.info];
            }
          }

          if(cb) cb();
        })
      },
      // 经方模板列表滚动加载
      scrollToLoad() {
        if(!this.isOver) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            let pageHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight);
            let viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
            let scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            if(pageHeight - viewportHeight - scrollHeight < 20) {
              this.page ++;
              this.getClassicalList();
            }
          }, 200);
        }
      },
      searchClassical() {
        this.$toast.loading({
          duration: 0,
          loadingType: 'spinner',
          message: '搜索中...'
        })
        this.page = 1;
        this.getClassicalList('search', () => {
          window.scrollTo(0, 0);
          this.$toast.clear();
          this.$refs.searchInput.blur();
        });
      },
      clearSearch() {
        this.searchKey = '';
        window.scrollTo(0, 0);
        this.page = 1;
        this.getClassicalList('search');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ClassicalPrescription/list.vue